import { Ability } from '@casl/ability';
import { type PossibleAbilities } from '@lightdash/common';

export const defaultAbility = new Ability<PossibleAbilities>();
